// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Mass Effect Universe - Star Systems Configuration
 * 
 * The galaxy of Mass Effect with Citadel, relay networks, and iconic locations
 */

export const starSystems = [
  {
    id: 1700,
    name: 'The Citadel',
    type: 'station',
    distance: 0,
    coordinates: { x: 45, y: 50, z: 0 },
    threat: 'SAFE',
    resources: 'GALACTIC HUB',
    services: ['refuel', 'repairs', 'trade', 'weapons', 'upgrades', 'modules'],
    tradeType: 'station_advanced',
    primaryColor: '#00d4ff',
    secondaryColor: '#0088ff',
    hasRings: true,
    description: 'Ancient Prothean space station. Seat of the Citadel Council and galactic government.'
  },
  {
    id: 1701,
    name: 'Omega',
    type: 'station',
    distance: 18,
    coordinates: { x: 28, y: 58, z: -5 },
    threat: 'HIGH',
    resources: 'BLACK MARKET',
    services: ['refuel', 'repairs', 'trade', 'weapons'],
    tradeType: 'remote',
    primaryColor: '#ff4400',
    secondaryColor: '#cc0000',
    hasRings: false,
    description: 'Lawless space station ruled by Aria T\'Loak. "Don\'t fuck with Aria."'
  },
  {
    id: 1702,
    name: 'Thessia',
    type: 'planet',
    distance: 22,
    coordinates: { x: 60, y: 62, z: 3 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade'],
    tradeType: 'luxury',
    primaryColor: '#8844ff',
    secondaryColor: '#aa66ff',
    hasRings: false,
    description: 'Asari homeworld. Ancient civilization with biotic mastery and Prothean archives.'
  },
  {
    id: 1703,
    name: 'Palaven',
    type: 'planet',
    distance: 25,
    coordinates: { x: 52, y: 35, z: 8 },
    threat: 'MODERATE',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'weapons'],
    tradeType: 'industrial',
    primaryColor: '#888888',
    secondaryColor: '#666666',
    hasRings: true,
    description: 'Turian homeworld. Military culture with strict hierarchy and discipline.'
  },
  {
    id: 1704,
    name: 'Sur\'Kesh',
    type: 'planet',
    distance: 20,
    coordinates: { x: 38, y: 42, z: -3 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'upgrades'],
    tradeType: 'agricultural',
    primaryColor: '#00ff88',
    secondaryColor: '#00cc66',
    hasRings: false,
    description: 'Salarian homeworld. Scientific advancement and intelligence operations.'
  },
  {
    id: 1705,
    name: 'Tuchanka',
    type: 'planet',
    distance: 28,
    coordinates: { x: 65, y: 45, z: -8 },
    threat: 'VERY HIGH',
    resources: 'LOW',
    services: ['refuel', 'exploration', 'repairs'],
    tradeType: 'remote',
    primaryColor: '#cc6600',
    secondaryColor: '#994400',
    hasRings: false,
    description: 'Krogan homeworld. Nuclear wasteland. Genophage-afflicted warrior race.'
  },
  {
    id: 1706,
    name: 'Rannoch',
    type: 'planet',
    distance: 30,
    coordinates: { x: 25, y: 65, z: 5 },
    threat: 'MODERATE',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'upgrades'],
    tradeType: 'industrial',
    primaryColor: '#9966ff',
    secondaryColor: '#7744cc',
    hasRings: false,
    description: 'Quarian homeworld, reclaimed from the Geth. Desert world with three suns.'
  },
  {
    id: 1707,
    name: 'Illium',
    type: 'planet',
    distance: 24,
    coordinates: { x: 58, y: 55, z: 10 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'weapons', 'upgrades'],
    tradeType: 'luxury',
    primaryColor: '#00ccff',
    secondaryColor: '#0099cc',
    hasRings: false,
    description: 'Asari colony. Corporate hub with loose regulations and thriving trade.'
  },
  {
    id: 1708,
    name: 'Noveria',
    type: 'planet',
    distance: 26,
    coordinates: { x: 32, y: 35, z: -10 },
    threat: 'MODERATE',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'upgrades'],
    tradeType: 'industrial',
    primaryColor: '#ccffff',
    secondaryColor: '#99ddff',
    hasRings: false,
    description: 'Ice world. Corporate research facilities conducting controversial experiments.'
  },
  {
    id: 1709,
    name: 'Ilos',
    type: 'planet',
    distance: 35,
    coordinates: { x: 70, y: 58, z: -12 },
    threat: 'HIGH',
    resources: 'PROTHEAN RUINS',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#00ff00',
    secondaryColor: '#00cc00',
    hasRings: false,
    description: 'Ancient Prothean world. Ruins hold secrets of the Conduit and Reaper cycle.'
  },
  {
    id: 1710,
    name: 'Virmire',
    type: 'planet',
    distance: 32,
    coordinates: { x: 48, y: 70, z: 8 },
    threat: 'VERY HIGH',
    resources: 'LOW',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#0088ff',
    secondaryColor: '#0066cc',
    hasRings: false,
    description: 'Tropical world. Site of Saren\'s base and a fateful decision.'
  },
  {
    id: 1711,
    name: 'Feros',
    type: 'planet',
    distance: 29,
    coordinates: { x: 55, y: 38, z: -6 },
    threat: 'HIGH',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs'],
    tradeType: 'remote',
    primaryColor: '#88ff00',
    secondaryColor: '#66cc00',
    hasRings: false,
    description: 'Ancient Prothean city-world. Zhu\'s Hope colony struggles against the Thorian.'
  }
];

export const starPositions = starSystems.reduce((acc, system) => {
  acc[system.id] = system.coordinates;
  return acc;
}, {});
